<template>
    <v-hover>
        <template v-slot:default="{ hover }">
            <v-card class="" 
            :to="to" 
            :disabled="disabled" 
            :tile="tile"
            :href="href"
            >
                <slot name="contents" :hover="hover"></slot>
                <v-fade-transition>
                    <v-overlay
                        v-if="hover && (to || href)"
                        absolute
                        :color="color"
                    >
                    </v-overlay>
                </v-fade-transition>
            </v-card>
        </template>
    </v-hover>
</template>

<script>
export default {
    name:"button-card",
    props:{
        color: {
            type: String,
            default: 'primary'
        },
        to: {
            type: String,
            default: undefined
        },
        href: {
            type: String,
            default: undefined
        },
        disabled: {
            type: Boolean,
            default: false
        },
        tile: {
            type: Boolean,
            default: false
        }
    },
}
</script>